import { Alert, Button } from "@growtherapy/sprout-ui";
import { CSSRPromptText } from "./constants";
import { faHexagonExclamation } from "@fortawesome/pro-solid-svg-icons";

type CSSRSPromptAlertProps = {
  onClose: () => void;
  patientName: string;
  onAdministerCSSRS: () => void;
  className?: string;
};

export function CSSRSPromptAlert({
  onClose,
  patientName,
  onAdministerCSSRS,
  className,
}: CSSRSPromptAlertProps) {
  return (
    <Alert
      actions={
        <Button
          className="whitespace-nowrap"
          use="secondary"
          onClick={onAdministerCSSRS}
        >
          {CSSRPromptText.CALL_TO_ACTION}
        </Button>
      }
      className={className}
      heading={CSSRPromptText.HEADING}
      headingAs="h3"
      icon={faHexagonExclamation}
      use="error"
      onClose={onClose}
    >
      <span className="fs-exclude data-dd-privacy">
        {`${patientName || "Your client"}`}
      </span>{" "}
      {`${CSSRPromptText.BODY}`}
    </Alert>
  );
}
